/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { isObject } from 'lodash';

// Components
import BulkActions from 'shared/ui/components/listings/BulkActions.vue';
import ListActions from 'shared/ui/components/listings/ListActions.vue';
import LiveSessionActions from 'ui/components/live-session/LiveSessionActions.vue';
import SearchBar from 'shared/ui/components/form-components/SearchBar.vue';
import SmartTable from 'shared/ui/components/tables/SmartTable.vue';

const __vue_script__ = {
    name: 'LiveSessionsList',

    components: {
        BulkActions,
        ListActions,
        LiveSessionActions,
        SearchBar,
        SmartTable
    },

    props: {
        params: {
            type: Object,
            required: true
        }
    },

    data() {
        const { resolvers } = this.params.currentController;
        const defaultResolver = resolvers.default || {};
        const { options: resolverOptions = {} } = defaultResolver;
        const { fpType } = resolverOptions;

        return {
            cols: [],
            eid: this.params.event._id,
            fpType,
            loading: false,
            metadata: {},
            resolverOptions,
            rows: [],
            searchTerm: '',
            sort: 'ASC',
            sortField: null,
            itemsPerPage: this.$services.meetings.MAX_MEETINGS_PER_PAGE,
        };
    },

    computed: {
        visibleRows() {
            if (!this.searchTerm) {
                return this.rows;
            }

            return this.rows.filter((row) => {
                return String(row.title).toLowerCase().includes(this.searchTerm.toLowerCase());
            });
        }
    },

    async created() {
        this.metadata = await this.$services.metadata.getMetadataForType(this.params.event._id, this.fpType);
        this.cols = this.getColsConfig();
        this.loadData();
    },

    methods: {
        /**
         * Loads the collection to display on the table
         */
        async loadData() {
            try {
                if (this.loading) {
                    return;
                }

                this.loading = true;
                const rows = await this.$services.appScripts.callAppScript(
                    this.params.event._id,
                    this.resolverOptions.appscriptUrl
                );

                this.rows = rows;
            } catch (error) {
                console.error('[LiveSessionsList] Could not load data', error.message);
                this.flashError(this.$i18n.t('general.try_later'));
            } finally {
                this.loading = false;
            }
        },

        /**
         * Flashes an error message
         *
         * @param {string} text the error message to display
         */
        flashError(text) {
            this.$notify({
                group: 'flashes',
                title: this.$i18n.t('general.error_occurred').toString(),
                text,
                type: 'error',
                duration: 5000
            });
        },

        /**
         * @returns {object[]} each column configuration
         */
        getColsConfig() {
            const cols = [{
                field: 'title',
                label: 'live_sessions.details.title',
                sortable: 'title',
                link: {
                    controllerKey: 'view'
                }
            },
            { field: 'type', label: 'live_sessions.details.type', cssClass: 'type-cell', noTruncate: true },
            { field: 'status', label: 'live_sessions.details.status', noTruncate: true },
            { field: 'starts_at', label: 'live_sessions.details.start_time', sortable: 'starts_at' },
            {
                actions: []
            }];

            for (const col of cols) {
                const meta = this.metadata[col.field];

                let label = col.field;
                if (isObject(meta) && meta.hasOwnProperty('label')) {
                    label = meta.label;
                }

                col.label = col.label || label;
            }

            return cols;
        },

        /**
         * Compiles a link in the context of the given cell
         *
         * @param {object} cellConfig the configuration for the cell
         * @param {object} item the FP typed item
         *
         * @returns {string} a compiled version of the link for this cell
         */
        cellLink(cellConfig, item) {
            if (!cellConfig.link) {
                return null;
            }

            return this.$utils.tables.cellLink(cellConfig.link, item, this.params.module, this.params.event);
        },

        /**
         * Sets the sortable field and reload the collection
         *
         * @param {object} cellConfig the configuration for the cell
         */
        setSortable(cellConfig) {
            const { sort, sortField } = this.$utils.tables.setSortable(cellConfig, this.sort, this.sortField);
            this.sort = sort;
            this.sortField = sortField;

            this.rows.sort((a, b) => {
                if (sort === 'ASC') {
                    return a[sortField] > b[sortField] ? 1 : -1;
                }

                return a[sortField] < b[sortField] ? 1 : -1;
            });
        },

        provider(item) {
            if (item.is_third_party) {
                return 'Embed';
            } else if (item.use_studio) {
                return 'SpotMe Studio';
            } else if (item.provider === 'none') {
                return 'None';
            } else {
                return 'RTMPS';
            }
        },

        status(item) {
            const fpSystem = item.fp_system || {};

            if (!item.is_third_party && (Object.keys(fpSystem).length === 0 || fpSystem.state === 'SCHEDULED' || fpSystem.state === 'STARTING') && !fpSystem.is_finished) {
                return ['SCHEDULED', ''];
            }
            if ((item.is_third_party || fpSystem.state === 'RUNNING') && !fpSystem.is_live && !fpSystem.is_finished) {
                return ['PREVIEW', 'info'];
            }
            if (fpSystem.is_live && !fpSystem.is_finished) {
                return ['LIVE', 'success'];
            }
            if (fpSystem.is_finished && !fpSystem.is_live) {
                return ['PAST', 'danger'];
            }
            if (fpSystem.is_published && fpSystem.is_live) {
                return ['PUBLISHED', 'warn'];
            }
            if (!item.vodWasGenerated && fpSystem.state === 'ERROR') {
                return ['ERROR', 'danger'];
            }
            return ['PROCESSING', ''];
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"live-sessions-list fp-typed-list"},[_c('smart-table',{ref:"itemsTable",attrs:{"track-by":"_id","hide-pagination":_vm.searchTerm.length > 0,"items-per-page":_vm.$services.liveStream.MAX_LIVE_SESSIONS_PER_PAGE,"items":_vm.visibleRows,"selectable":false,"total-items":_vm.visibleRows.length,"full-list-provided":true},scopedSlots:_vm._u([{key:"filters",fn:function(ref){return [_c('search-bar',{attrs:{"show-no-result":false},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}})]}},{key:"actions",fn:function(ref){return [_c('list-actions',{attrs:{"controller":_vm.params.currentController,"module":_vm.params.module,"event":_vm.params.event,"metadata":_vm.metadata},on:{"reload":_vm.loadData}})]}},{key:"headers",fn:function(ref){return _vm._l((_vm.cols),function(c){return _c('th',{class:[c.cssClass || c.field ].concat( _vm.$utils.tables.getCellSortClass(c, _vm.sort, _vm.sortField)),on:{"click":function($event){return _vm.setSortable(c)}}},[_c('span',[_vm._v(_vm._s(_vm.$te(c.label) ? _vm.$t(c.label) : c.label))]),_c('i',{staticClass:"ic-icon"})])})}},{key:"row",fn:function(ref){
var item = ref.item;
return _vm._l((_vm.cols),function(c){return _c('td',{class:_vm.$utils.tables.cellClasses(c, item)},[(c.field === 'title')?[_c('a',{attrs:{"href":_vm.cellLink(c, item),"target":"_blank"}},[_vm._v(_vm._s(_vm.$utils.tables.render(c, item)))]),(_vm.$services.user.isSuperAdmin())?_c('div',{staticClass:"sub-text"},[_c('small',[_vm._v(_vm._s(_vm.provider(item)))])]):_vm._e()]:(c.field === 'type')?[(item.session_type === 'IN_PERSON' || (!item.session_type && item.provider === 'none'))?_c('span',[_vm._v(_vm._s(_vm.$t('live_sessions.details.in_person'))),_c('i',{staticClass:"ic-in-person"})]):_vm._e(),(item.session_type === 'REMOTE' || (!item.session_type && item.provider !== 'none'))?_c('span',[_vm._v(_vm._s(_vm.$t('live_sessions.details.remote'))),_c('i',{staticClass:"ic-remote"})]):_vm._e(),(item.session_type === 'HYBRID')?_c('span',[_vm._v(_vm._s(_vm.$t('live_sessions.details.hybrid'))),_c('i',{staticClass:"ic-in-person"}),_c('i',{staticClass:"ic-remote"})]):_vm._e()]:(c.field === 'status')?[_c('span',{staticClass:"badge",class:_vm.status(item)[1]},[_vm._v(_vm._s(_vm.status(item)[0]))])]:(c.field === 'starts_at')?[_c('span',[_vm._v(_vm._s(_vm.$utils.time.tsToFormat(item.start_time, 'LLLL', _vm.params.event.timezone)))])]:[_c('live-session-actions',{staticClass:"actions",attrs:{"item":item,"event":_vm.params.event},on:{"error":function($event){return _vm.flashError($event)},"deleted":_vm.loadData}})]],2)})}}])})],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "LiveSessionsList.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__